import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const NAMES = ['Martín', 'Lucía', 'Federico', 'Camila', 'Agustín', 'Florencia', 'Mateo', 'Valentina', 'Joaquín', 'Brenda', 'Nicolás', 'Julieta', 'Tomás', 'Antonella', 'Santiago', 'Rocío'];
const SURNAMES = ['García', 'López', 'Fernández', 'Rodríguez', 'Pérez', 'Sosa', 'Romero', 'Álvarez', 'Torres', 'Ruiz', 'Gómez', 'Díaz'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bariloche', 'Resistencia', 'Posadas'];
interface PopupData {
  name: string;
  city: string;
  time: number;
}
export function PurchasePopup() {
  const [currentPopup, setCurrentPopup] = useState<PopupData | null>(null);
  useEffect(() => {
    const showRandomPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomSurname = SURNAMES[Math.floor(Math.random() * SURNAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setCurrentPopup({
        name: `${randomName} ${randomSurname}`,
        city: randomCity,
        time: randomTime
      });
      // Auto dismiss after 6 seconds
      setTimeout(() => {
        setCurrentPopup(null);
      }, 6000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showRandomPopup, 5000);
    // Then show every 15-25 seconds
    const interval = setInterval(() => {
      showRandomPopup();
    }, Math.floor(Math.random() * 10000) + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-155">
      {currentPopup && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] bg-white rounded-xl shadow-2xl border border-cream-dark p-4 flex items-start gap-4" data-id="element-156">
          <button onClick={() => setCurrentPopup(null)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar" data-id="element-157">
            <X size={16} data-id="element-158" />
          </button>

          <div className="flex-shrink-0 mt-1" data-id="element-159">
            <div className="w-10 h-10 bg-primary-light rounded-full flex items-center justify-center text-white" data-id="element-160">
              <CheckCircle2 size={20} data-id="element-161" />
            </div>
          </div>

          <div className="flex-1 pr-4" data-id="element-162">
            <p className="text-sm text-brown font-medium" data-id="element-163">
              {currentPopup.name} de {currentPopup.city}
            </p>
            <p className="text-xs text-brown-light mt-1" data-id="element-164">
              acaba de comprar{' '}
              <span className="font-semibold text-primary" data-id="element-165">
                Comida Natural para Perros
              </span>
            </p>
            <p className="text-xs text-gray-400 mt-2" data-id="element-166">
              hace {currentPopup.time}{' '}
              {currentPopup.time === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}